import React, { PureComponent } from 'react';
import List from '../standardAttributes/List';
import message from '../../../helper/message';
import { getNodeInfo } from '../../../helper/config';

export default class BelowPower extends PureComponent {
  getDependOnBlock = value => {
    const { configuration } = this.props;
    const block =
      value === 'PB6OUTH'
        ? configuration.workSurface.blocks.surfaceBottom
        : configuration.workSurface.blocks.surfaceTop;
    return block;
  };

  importModel = async (value, block) => {
    const { appApi, attributeName, configuration } = this.props;
    const { hasScene, blockDependOn } = appApi.config.getAttribute(
      attributeName
    );
    if (!hasScene || value === 'None') return;
    if (!block)
      throw new Error(`Attribute ${attributeName} missing dependOn block!`);

    const product = appApi.config.getProduct(value);
    const nodeInfo = getNodeInfo(product);
    const insertion = block.determineInsertion(nodeInfo);
    if (!insertion.isInsertionPossible)
      return message.warn(
        `Fail to insert ${attributeName}, the block doesn't have enough space.`
      );

    const transform = block.getInsertTransform(insertion);
    const parent = configuration[blockDependOn[0][0]].modelId;
    const blocksData = appApi.config.getProductBlockData(attributeName, value);
    const importOptions = { blocksData, parent, transform };
    const importState = await appApi.model.importModel(
      product.sceneId,
      importOptions
    );
    block.occupyBlocks(importState.modelId, insertion);
    return importState;
  };
  render() {
    const { attributeName, appApi, configuration } = this.props;
    const listOptions = appApi.config.getAttributeAvailableValues(
      attributeName,
      configuration
    );
    return (
      <List
        {...this.props}
        options={listOptions}
        getDependOnBlock={this.getDependOnBlock}
        importModel={this.importModel}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Attributes/nonStandardAttributes/BelowPower.js